import React, { useState, useEffect, useRef } from "react";
import {
  Loader,
  Dimmer,
  TableCell,
  TableRow,
  TableBody,
} from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { formatMoneda } from "../../util/varios";
import moment from "moment";
import useTableScroll from "../useTableScroll";
import CatalogoListPagos from "../../catalogos/catalogodePagos";
import CatalogoSupervisor from "../../catalogos/catalogoSupervisor";

const ReversarTransaccion = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));
  const cmbCedula = ["J", "V", "G", "P"];

  const headCells = [
    { label: "FORMA DE PAGO", textAlign: "center" },
    { label: "MONTO", textAlign: "center" },
    { label: "MONTO AL CAMBIO", textAlign: "center" },
  ];

  const txtFecha = useRef();
  const txtConcepto = useRef();
  const txtMotivo = useRef();
  const btnConsultar = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnProducto = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtNumAnticipo = useRef();
  const txtRifVende = useRef();
  const txtDias = useRef();
  const txtFechaVencimiento = useRef();

  const [idpago, setIdPago] = useState(null);
  const [body, setBody] = useState(null);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitadoAceptar, setHabilitadoAceptar] = useState(true);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoCli, setHabilitadoCli] = useState(false);
  const [numNota, setNumNota] = useState("");
  const [tipoPago, setTipoPago] = useState("");
  const [cedRif, setCedRif] = useState("");
  const [nomVendedor, setNomVendedor] = useState("");
  const [nomCliente, setNomCliente] = useState("");
  const [dirCliente, setDirCliente] = useState("");
  const [combomoneda, setComboMoneda] = useState([]);
  const [totaldolares, setTotaldolares] = useState(0.0);
  const [totales, setTotales] = useState(0.0);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idnotaentre") {
          seleccionarAnticipo(event.target.value);
        }
      }
    }
  };

  const { TblContainer, TblHead } = useTableScroll(headCells, {
    fn: (items) => {
      return items;
    },
  });

  const blanquear = () => {
    cmbRif.current.selectedIndex = -1;
    txtRif.current.value = "";
    txtNumAnticipo.current.value = "";
    txtFecha.current.value = "";
    txtConcepto.current.value = "";
    txtMotivo.current.value = "";
    txtMotivo.current.setAttribute("disabled", "disabled");
    btnCancela.current.focus();
    setBody();
    setActivate(false);
    setHabilitado(false);
    setHabilitadoCli(false);
    setHabilitadoBot(true);
    setHabilitarCat(true);
    setHabilitadoAceptar(true);
    setIdPago(null);
    setVisibleBtn("visible");
    setNumNota("");
    setTipoPago("");
    setNomCliente("");
    setDirCliente("");
    setNomVendedor("");
    setCedRif("");
    setRecords([]);
    setTotaldolares(0.0);
    setTotales(0.0);
    setMostrar1(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const handleCloseMensaje = () => {
    if (mensaje.titulo === "Exito.") {
      blanquear();
    }
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarCliente = (rif, tecla, ids) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "";
    let nomid2 = "cliente";
    let id;
    if (rif === 0 && tecla === 0) {
      nomid = "idagente";
      id = ids;
    } else {
      nomid = "rif";
      id = rif;
    }
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
            txtRif.current.value = response.data.rif.trim().substring(1, 10);
            setNomCliente(response.data.nombre);
            setDirCliente(response.data.direccion.trim());
            if (tecla === 13) {
              txtFecha.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarVendedor = (idv) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "vendedor";
    let id = idv === null ? "0" : idv;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setCedRif(response.data.rif);
            setNomVendedor(response.data.nombre);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El usuario no tiene un vendedor asociado",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = (id, vmoney) => {
    let campos = "*";
    let nomtab = "pagodetalle";
    let nomid = "idpago";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            let datos = [];
            let idmoney;
            let predeterminada = 0.0;
            let valormoney = 0.0;
            let simbolo;

            for (let i = 0; i < response.data.length; i++) {
              idmoney = response.data[i].idmoneda;

              for (let a = 0; a < combomoneda.length; a++) {
                if (parseInt(combomoneda[a].idmoneda) === parseInt(idmoney)) {
                  simbolo = combomoneda[a].simbolo;

                  if (combomoneda[a].subpredeterminada === true) {
                    valormoney = response.data[i].factorcambio;
                    predeterminada = response.data[i].factorcambio;
                  } else {
                    valormoney = response.data[i].factorcambio;
                    predeterminada = response.data[i].factorcambio;
                  }
                }
              }

              datos.push({
                forma:
                  response.data[i].tipo === "1"
                    ? "Efectivo Bs"
                    : response.data[i].tipo === "2"
                      ? "Tarjeta(Debito) Bs"
                      : response.data[i].tipo === "3"
                        ? "Tarjeta(Crédito) Bs"
                        : response.data[i].tipo === "4"
                          ? "Pago Movil Bs"
                          : response.data[i].tipo === "5"
                            ? "Deposito Bancario Bs"
                            : response.data[i].tipo === "6"
                              ? "Transferencia Bancaria Bs"
                              : "Divisa" + " " + simbolo,
                montos: response.data[i].monto,
                fechapago: response.data[i].fechaemision,
                tipodivisa: response.data[i].idmoneda,
                montoalcambio:
                  response.data[i].tipo === "7"
                    ? response.data[i].monto * parseFloat(valormoney)
                    : response.data[i].monto,
                montodefinic:
                  response.data[i].tipo === "7"
                    ? (response.data[i].monto * parseFloat(valormoney)) /
                    parseFloat(predeterminada)
                    : response.data[i].monto / parseFloat(predeterminada),
                notacredito: response.data[i].numcredito,
                valormoneda: response.data[i].factorcambio,
                idbanco: response.data[i].idcuenta,
                referencia: response.data[i].nroreferencia,
                simbolo: simbolo,
              });
            }

            let montototal = 0.0;

            for (let e = 0; e < datos.length; e++) {
              montototal =
                parseFloat(montototal) + parseFloat(datos[e].montoalcambio);
            }

            setRecords(datos);
            setTotales(montototal);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarAnticipo = (num) => {
    let campos = "*";
    let nomtab = "registropago";
    let nomid = "numpago";
    let id = num;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            let montod = 0.0;

            txtFecha.current.value = moment(response.data.fecharegistro).format(
              "YYYY-MM-DD"
            );
            txtConcepto.current.value = response.data.concepto;
            setIdPago(response.data.idpago);
            seleccionarCliente(0, 0, response.data.idcliente);
            seleccionarVendedor(response.data.idvendedor);
            setNumNota(response.data.numpago);
            setTipoPago(response.data.tipofac);
            seleccionarDetalle(response.data.idpago, response.data.valormoneda);
            montod = response.data.total;
            setTotaldolares(montod);

            if (response.data.statusreverso === 1) {
              setHabilitadoAceptar(true);
              txtMotivo.current.setAttribute("disabled", "disabled");
              btnCancela.current.focus();
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "Este Pago ya fue Revesado el dia " +
                  moment(response.data.fechareverso).format("YYYY-MM-DD"),
                icono: "informacion",
              });
            } else if (
              response.data.tipofac === "AN" &&
              response.data.status === 1
            ) {
              setHabilitadoAceptar(true);
              txtMotivo.current.setAttribute("disabled", "disabled");
              btnCancela.current.focus();
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: `¡ Este Anticipo fue Utilizado en la Nota de Entrega N° ${response.data.numfactura} !`,
                icono: "informacion",
              });
            } else {
              setHabilitadoAceptar(false);
              txtMotivo.current.removeAttribute("disabled");
              setTimeout(() => txtMotivo.current.focus(), 300);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un Pago con este Código",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        blanquear();
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMonedas = () => {
    let campos = "*";
    let nomtab = "moneda";
    let orden = "idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setComboMoneda(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (idpago !== null) {
      if (txtFecha.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la Fecha !",
          icono: "informacion",
        });
        sigue = false;
        txtFecha.current.focus();
      } else if (txtRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione el Cliente !",
          icono: "informacion",
        });
        sigue = false;
        txtRif.current.focus();
      } else if (txtRifVende.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Los Datos del Vendedor no deben ir Vacios !",
          icono: "informacion",
        });
        sigue = false;
        txtRifVende.current.focus();
      } else if (txtConcepto.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Describa el Concepto del Pago !",
          icono: "informacion",
        });
        sigue = false;
        txtConcepto.current.focus();
      } else if (txtMotivo.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Describa el Motivo del reverso !",
          icono: "informacion",
        });
        sigue = false;
        txtMotivo.current.focus();
      } else if (records.length <= 0) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Pago !",
          icono: "informacion",
        });
        sigue = false;
      } else {
        sigue = true;
      }

      if (sigue) {
        setBody({
          fechareverso: moment(fechasistema).format("YYYY-MM-DD"),
          fechapago: txtFecha.current.value,
          idpago: idpago,
          idusuario: idVendedor,
          post: false,
          motivo: txtMotivo.current.value,
        });

        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: "Esta Seguro de Reversar este Pago.",
          icono: "confirmacion",
        });
      }
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/Caja_Ingreso/reversarpago`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcaja === idpago) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "El Pago Fue Reversado Correctamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        btnProducto.current.focus();
      } else if (event.target.name === "dias") {
        let dias = txtDias.current.value;
        if (txtDias.current.value > 0) {
          let fechaV = moment(fechasistema)
            .add(dias.toString(), "days")
            .format("YYYY-MM-DD");
          let cambia = event.target.value;
          let dd =
            dias === cambia
              ? cambia
              : txtFechaVencimiento.current.value.substring(8, 10);

          if (event.target.value !== dd) {
            let fechaV = moment(fechasistema)
              .add(dias.toString(), "days")
              .format("YYYY-MM-DD");
          }
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleAceptaDatosAnticipos = (values) => {
    setMostrar(false);

    txtNumAnticipo.current.value = values.numpago.trim();
    seleccionarAnticipo(values.numpago);
  };

  /* const onReversar = (value) => {
    if (value === "AUTORIZADO") {
      setHabilitadoBot(false);
      setVisibleBtn("hidden");
      setHabilitarCat(false);
      setHabilitado(false);
      setHabilitadoCli(false);
      setTimeout(() => txtNumAnticipo.current.focus(), 300);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  }; */

  const onReversar = (e) => {
    e.preventDefault();
    if (accbtnndebito && accbtnndebito.toString().substring(2, 3) === "1") {
      setHabilitadoBot(false);
      setVisibleBtn("hidden");
      setHabilitarCat(false);
      setHabilitado(false);
      setHabilitadoCli(false);
      setTimeout(() => txtNumAnticipo.current.focus(), 300);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  useEffect(() => {
    seleccionarMonedas();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow h-100">
            <div className="col-md-12 row border-azul mx-auto justify-content-between rounded py-1">
              <div
                className="col-md-12 row mx-auto d-flex justify-content-between mb-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                  <div className="col-md-3">
                    <h3>Reversar Pagos</h3>
                  </div>
                  <div className="col-md-2 d-flex justify-content-end">
                    <a href="/inicio" className="text-light ">
                      <i className="fas fa-times mx-2"></i>
                      <span className="fw-bold">Salir</span>
                    </a>
                  </div>
                </div>

                <div className="colfull col-pd-300">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      N° PAGO:
                    </label>
                    <input
                      type="text"
                      disabled={habilitarCat}
                      ref={txtNumAnticipo}
                      autoComplete="off"
                      name="idnotaentre"
                      onChange={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      onKeyUp={handleInputNumeroChange}
                      onBlur={handleInputNumeroChange}
                      className="form-control form-control-lg"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      disabled={habilitarCat}
                      type="button"
                      onClick={() => setMostrar(true)}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className="col-pd-240 mx-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      disabled={!habilitado}
                      ref={txtFecha}
                      className="form-control text-uppercase fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>

                <div className="colfull col400">
                  <label className="text-end">
                    TIPO DE PAGO:
                    {tipoPago !== "" && (
                      <span className="col fw-bold text-danger">
                        {tipoPago === "AN" ? " ANTICIPO" : "NOTA DE ENTREGA"}
                      </span>
                    )}
                  </label>
                </div>
              </div>

              <div
                className="colfull1070 colfull60p mx-auto mb-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded">
                  <span className="fw-bold">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-1 col-md-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled={!habilitadoCli}
                      className="form-select form-select-sm col-md-3 text-center "
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled={!habilitadoCli}
                      maxLength={9}
                      type="text"
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-1 col-md-7">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomCliente}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-1 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={dirCliente}
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 colfull40p mx-auto mb-1 row"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded">
                  <span className="fw-bold">Datos del Vendedor</span>
                  <div className="input-group input-group-sm col-pd-240 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                      style={{ height: "85%" }}
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      ref={txtRifVende}
                      className="form-control fs-6"
                      style={{ height: "85%" }}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={cedRif}
                    />
                  </div>
                  <div className="input-group input-group-sm col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                      style={{ height: "85%" }}
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      style={{ height: "85%" }}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomVendedor}
                    />
                  </div>
                </div>
                <div className="col-md-6"></div>
              </div>

              <div className="col-md-12 row mx-auto px-0 m-0">
                <div className="input-group input-group-sm mb-1 px-0 border-azul rounded col-md-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CONCEPTO:
                  </label>
                  <textarea
                    className="form-control uppercase fs-6"
                    ref={txtConcepto}
                    disabled={!habilitado}
                    aria-label="With textarea"
                    style={{ minHeight: 50 }}
                    defaultValue={""}
                  />
                </div>
                {/* 
                <div
                  className="col-3 row m-0 px-0 d-flex justify-content-center border-azul py-2"
                  style={{ background: "#cfe2ff", borderRadius: "3px" }}
                >
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(1)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-money-bill-alt fs-5 mr-2"></i>{" "}
                      Efectivo Bs
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(7)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-dollar-sign fs-5 mr-2"></i> Divisas
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(2)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-credit-card fs-5 mr-2"></i> Tarjeta
                      de Debito
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(3)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fab fa-cc-visa fw-bold fs-5 mr-2"></i>{" "}
                      Tarjeta de Credito
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(6)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-money-check fs-5 mr-2"></i> Deposito
                      Bancario
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(5)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-laptop fs-5 mr-2"></i> Transferencia
                      Bancaria
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(4)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-mobile-alt fs-5 mr-2"></i> Pago Movil
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center"></div>
                </div> */}

                <div className="col-12 px-0">
                  <div className="col-12 px-0">
                    <TblContainer
                      container={{
                        height: "280px",
                        width: "100%",
                        overflow: "auto",
                        padding: "2px",
                      }}
                    >
                      <TblHead />
                      <TableBody className="overflow-hidden table-bordered">
                        {records &&
                          records.map((item, index) => (
                            <TableRow
                              key={index}
                              style={{ padding: "0", cursor: "pointer" }}
                            >
                              <TableCell className="align-baseline text-center">
                                {item.forma}
                              </TableCell>
                              <TableCell className="align-middle text-right">
                                {formatMoneda(
                                  item.montos
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                              </TableCell>
                              <TableCell className="align-baseline text-right">
                                {formatMoneda(
                                  item.montoalcambio
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </TblContainer>
                  </div>
                  <div
                    className="col-12 px-0 row m-0 d-flex align-items-center border-azul"
                    style={{ borderRadius: "3px", fontSizeAdjust: "0.5" }}
                  >
                    <div className="col-12 row m-0 px-0 border-azul">
                      <div className="col-8 px-0">
                        <div className="input-group input-group-sm px-0 border-azul rounded col-md-12">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            MOTIVO REVERSO:
                          </label>
                          <textarea
                            className="form-control uppercase fs-6"
                            ref={txtMotivo}
                            disabled
                            autoComplete="off"
                            onChange={(e) =>
                              (e.target.value = e.target.value.toUpperCase())
                            }
                            aria-label="With textarea"
                            style={{ minHeight: 70 }}
                            defaultValue={""}
                          />
                        </div>
                      </div>
                      <div
                        className="col-4 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2"
                        style={{
                          background: "#cfe2ff",
                          borderRadius: "3px",
                          fontSizeAdjust: "0.5",
                        }}
                      >
                        <div
                          className="col-12 row m-0"
                          style={{ fontSizeAdjust: "0.5" }}
                        >
                          <label className="col-4 px-1 text-left fs-5">
                            Total $:{" "}
                          </label>
                          <span className="col px-0 fw-bold text-right fs-5">
                            &nbsp;
                            {formatMoneda(
                              totaldolares
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </span>
                        </div>
                        <div
                          className="col-12 row m-0"
                          style={{ fontSizeAdjust: "0.5" }}
                        >
                          <label className="col-4 px-1 text-left fs-5">
                            Total Bs:{" "}
                          </label>
                          <span className="col px-0 fw-bold text-right fs-5">
                            &nbsp;
                            {formatMoneda(
                              totales
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="colfull40p row m-0">
                <div className="col-md-12"></div>
              </div>
              <div className="col-md-12 mt-auto px-0">
                {visibleBtn === "visible" ? (
                  <div className="col-pd-botones">
                    <div className="col-pd-150 row m-0 px-0">
                      <button
                        disabled={!habilitadoBot}
                        ref={btnConsultar}
                        onClick={onReversar}
                        className="btn btn-sm col ml-1 btn-info rounded-pill"
                        title="Reversar Pago"
                      >
                        <i className="fas fa-eye"> Reversar</i>{" "}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="col-pd-botonesd row m-0 ml-auto">
                    <button
                      ref={btnAcepta}
                      disabled={habilitadoAceptar}
                      onClick={onChangeValidar}
                      className="btn btn-sm col ml-1 rounded-pill btn-success"
                    >
                      <i className="fas fa-check-circle"> ACEPTAR</i>
                    </button>
                    <button
                      ref={btnCancela}
                      disabled={habilitadoBot}
                      onClick={blanquear}
                      className="btn btn-danger col ml-1 btn-sm rounded-pill"
                    >
                      <i className="fas fa-window-close"> Cancelar</i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <CatalogoListPagos
        show={mostrar}
        condi="statusreverso isnull and status != 4"
        onHideCancelar={() => setMostrar(false)}
        onHideAceptaCatalogo={handleAceptaDatosAnticipos}
      />
      <CatalogoSupervisor
        show={mostrar1}
        ope={3}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={onReversar}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje} onHide={handleCloseMensaje} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default ReversarTransaccion;



// WEBPACK FOOTER //
// ./src/components/finanzas/reversarPago.js